import { render, staticRenderFns } from "./CertificateManagement.vue?vue&type=template&id=1a02db31"
import script from "./CertificateManagement.vue?vue&type=script&lang=js"
export * from "./CertificateManagement.vue?vue&type=script&lang=js"
import style0 from "./CertificateManagement.vue?vue&type=style&index=0&id=1a02db31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports